import React, { FC, memo } from "react";

import { Flex, Icon, Text } from "@/eworkitComponents";

export interface IPasswordValidationField {
  text: string;
  invalid: boolean;
  showIcon?: boolean;
}

export const PasswordValidationField: FC<IPasswordValidationField> = memo(props => {
  return (
    <Flex direction="column">
      <Flex align="center" innerMargin="xs">
        <Text color={!props.invalid ? "secondary" : "primary"} size="sm" text={`• ${props.text}`} />
        {props.showIcon && (
          <Icon color={!props.invalid ? "success" : "danger"} icon={!props.invalid ? "checkbox" : "close"} />
        )}
      </Flex>

      {props.children}
    </Flex>
  );
});
